<template>
    <div class="p-5 footer-wrapper" data-cy="nav-footer">
        <div class="footer">
            <div class="footer-content">
                <div class="top-row" data-cy="footer-top-row">
                    <div class="flex flex-column">
                        <div class="footer-logo flex flex-wrap align-items-center">
                            <!-- <img src="@/assets/logos/clarity-logo-small-grey.svg"> -->
                            <img
                                src="https://website-public-assets.clarityglobal.com/rdapp/clarity-logo-small-grey.svg"
                                class="footer-clarity"
                            />
                            <img
                                src="https://website-public-assets.clarityglobal.com/saleswebsitevuejs/images/footer-logos/chartered-planners-footer-logo.png"
                                class="footer-tall"
                            />
                            <img
                                src="https://website-public-assets.clarityglobal.com/saleswebsitevuejs/images/footer-logos/citywire-clarity-2024.png"
                                class="footer-tall"
                            />
                            <img
                                src="https://website-public-assets.clarityglobal.com/saleswebsitevuejs/images/footer-logos/ft-adviser-clarity-2024.png"
                                class="footer-tall"
                            />
                            <img
                                src="https://website-public-assets.clarityglobal.com/saleswebsitevuejs/images/footer-logos/iso270012022footerlogo.png"
                                class="footer-iso"
                            />
                        </div>
                        <div class="footer-links" data-cy="footer-links">
                            <div class="link">
                                <a :href="clarityURL + '/whatwedo'" target="_blank"> What we Do </a>
                            </div>
                            <div class="link">
                                <a
                                    href="https://website-public-assets.clarityglobal.com/saleswebsitevuejs/pdf/ethics.pdf"
                                    target="_blank"
                                >
                                    Ethics
                                </a>
                            </div>
                            <div class="link">
                                <a href="faqs/questions"> FAQs </a>
                            </div>
                            <div class="link">
                                <a
                                    href="https://website-public-assets.clarityglobal.com/saleswebsitevuejs/pdf/complaints.pdf"
                                    target="_blank"
                                >
                                    Complaints
                                </a>
                            </div>
                            <div class="link">
                                <a
                                    href="https://website-public-assets.clarityglobal.com/saleswebsitevuejs/pdf/privacycookiespolicy.pdf"
                                    target="_blank"
                                >
                                    Privacy & Cookies
                                </a>
                            </div>
                            <div class="link">
                                <a
                                    href="https://website-public-assets.clarityglobal.com/saleswebsitevuejs/pdf/termsofbusiness.pdf"
                                    target="_blank"
                                >
                                    Terms of Business
                                </a>
                            </div>
                            <div class="link">
                                <a
                                    href="https://website-public-assets.clarityglobal.com/saleswebsitevuejs/pdf/feeschedule.pdf"
                                    target="_blank"
                                >
                                    Fees
                                </a>
                            </div>
                        </div>
                        <div class="footer-dropdown" data-cy="footer-dropdown">
                            <Dropdown
                                class="link"
                                v-model="menuOptSelected"
                                :options="linkOptions"
                                optionLabel="label"
                                @change="goTo($event)"
                            />
                        </div>
                    </div>
                </div>
                <div class="bottom-row" data-cy="footer-bottom-row">
                    <div class="extra-small-text grey">
                        <strong>Contact us:</strong> 1 Crown Square, Woking - Surrey, GU21 6HR - United Kingdom |
                        <a href="tel:+448003687511" class="grey">+44 800 368 7511</a>|
                        <a href="mailto:enquiries@clarityglobal.com" class="extra-small-text grey underline"
                            >enquiries@clarityglobal.com |&nbsp;</a
                        >
                        © 2003 - {{ getYear() }} clarity Ltd. clarity is authorised and regulated by the Financial
                        Conduct Authority. VAT No 164 1741 18. Reg No in England and Wales: 3466459.
                    </div>
                </div>
                <div class="mobile-bottom-row" data-cy="footer-bottom-row-mobile">
                    <div class="extra-small-text grey">
                        <strong>Contact us:</strong> 1 Crown Square, Woking - Surrey, GU21 6HR - United Kingdom |
                        <a href="tel:+448003687511" class="grey">+44 800 368 7511</a>
                        <a href="mailto:enquiries@clarityglobal.com" class="extra-small-text grey underline"
                            >| enquiries@clarityglobal.com</a
                        >
                        © 2003 - {{ getYear() }} clarity Ltd. clarity is authorised and regulated by the Financial
                        Conduct Authority. VAT No 164 1741 18.
                    </div>
                    <div class="extra-small-text grey">Reg No in England and Wales: 3466459.</div>
                </div>
            </div>
            <div class="icon-tray flex" data-cy="footer-icon-tray">
                <!-- <i class="pi pi-facebook"></i> -->
                <a href="https://www.youtube.com/@clarityltd" target="_blank"
                    ><img
                        class="clarity-margin-right-s"
                        src="https://website-public-assets.clarityglobal.com/rdapp/youtube-icon-active.svg"
                /></a>
                <a href="https://www.instagram.com/clarity_global/" target="_blank"
                    ><img
                        class="clarity-margin-right-s"
                        src="https://website-public-assets.clarityglobal.com/rdapp/instagram-icon-active.svg"
                /></a>
                <a href="http://www.linkedin.com/company/1242754" target="_blank"
                    ><img
                        class="clarity-margin-right-s"
                        src="https://website-public-assets.clarityglobal.com/rdapp/linkedin-icon-active.svg"
                /></a>
            </div>
        </div>
        <HelpLauncher />
    </div>
</template>

<script>
import { ref } from 'vue';
import HelpLauncher from '@/components/common/HelpLauncher';

export default {
    components: {
        HelpLauncher,
    },
    setup() {
        const getYear = () => {
            let date = new Date();
            return date.getFullYear();
        };

        const clarityURL = process.env.VUE_APP_CLARITYURL;

        const linkOptions = ref([
            {
                label: 'About Us',
                link: clarityURL + '/aboutintro',
            },
            {
                label: 'Ethics',
                link: 'https://website-public-assets.clarityglobal.com/saleswebsitevuejs/pdf/ethics.pdf',
            },
            {
                label: 'FAQs',
                to: '/faqs/questions',
            },
            {
                label: 'Complaints',
                link: 'https://website-public-assets.clarityglobal.com/saleswebsitevuejs/pdf/complaints.pdf',
            },
            {
                label: 'Privacy & Cookies',
                link: 'https://website-public-assets.clarityglobal.com/saleswebsitevuejs/pdf/privacycookiespolicy.pdf',
            },
            {
                label: 'Terms of Business',
                link: 'https://website-public-assets.clarityglobal.com/saleswebsitevuejs/pdf/termsofbusiness.pdf',
            },
            {
                label: 'Fees',
                link: 'https://website-public-assets.clarityglobal.com/saleswebsitevuejs/pdf/feeschedule.pdf',
            },
        ]);

        const menuOptSelected = ref(linkOptions.value[0]);

        const goTo = (link) => {
            window.open(link.value.link, '_blank');
        };

        return {
            getYear,
            goTo,
            linkOptions,
            menuOptSelected,
            clarityURL,
        };
    },
};
</script>

<style lang="scss">
.footer-wrapper {
    display: flex;
    position: relative;
    width: 100%;
    bottom: 0;
    margin-top: 30px;
    color: var(--clarity-grey);
}

.footer {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;

    @include mob-sm {
        flex-direction: column;
        align-items: start;
    }
}

.top-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: 10px;

    @include md {
        flex-direction: column;
        align-items: flex-start;
    }

    @include mob {
        flex-direction: column;
        align-items: flex-start;
    }
}

.bottom-row {
    color: var(--clarity-grey);
    display: flex;
    flex-direction: column;
    margin-right: 10%;

    @include mob {
        display: none;
    }

    .extra-small-text {
        color: var(--clarity-grey);
    }
}

.footer-logo {
    color: var(--clarity-grey);
    margin-bottom: 13px;
}
.footer-logo img {
    margin-right: 30px;
}
.cii-logo {
    width: 50px;
    height: 54px;
}

.footer-links {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;

    @include mob-sm {
        display: none;
    }
}

.footer-dropdown {
    display: none;
    @include mob-sm {
        display: flex;
    }
}

.link {
    margin-right: 30px;

    a {
        color: var(--clarity-grey);

        &:hover {
            color: var(--clarity-blue);
        }
    }
}

.icon-tray {
    justify-content: flex-end;
    margin-right: 80px;

    i {
        font-size: 24px;
        margin-right: 30px;

        &:hover {
            color: var(--clarity-blue);
        }
    }

    @include mob-md {
        padding-top: 20px;
    }
}

.mobile-bottom-row {
    display: flex;
    flex-direction: column;
    width: 80%;

    @include tablet-up {
        display: none;
    }

    .extra-small-text {
        color: var(--clarity-grey);
    }
}

.p-dropdown {
    &.link {
        background: transparent;
        border: none;

        .p-dropdown-label {
            color: var(--clarity-grey);
            font-weight: normal;
            font-size: 14px;
            padding-left: 0;
            padding-right: 0;
        }
    }
}

.footer-clarity {
    height: 40px;
}
.footer-iso {
    height: 88px;
}
.footer-tall {
    height: 100px;
}

@media only screen and (max-width: 1366px) {
    .footer-iso {
        height: 78px;
    }
    .footer-tall {
        height: 90px;
    }
}
@media only screen and (max-width: 1024px) {
    .footer-iso {
        height: 70px;
    }
    .footer-tall {
        height: 80px;
    }
}

@media only screen and (max-width: 1024px) {
    .footer-logo img {
        margin-right: 20px;
    }
}
@media only screen and (max-width: 375px) {
    .footer-logo img {
        margin-right: 10px;
    }
}
</style>
